import React, { useState, JSX } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';
import { ApiCancelRequest } from '@ibe/api';
import fallback from '../../../_Translations/generated/cancel-request.en.t.json';
import Keys from '../../../_Translations/generated/cancel-request.en.t.json.keys';
import useTranslation from '../../Hooks/useTranslation';

export interface Props {
  onSendAction: (cancelRequest: ApiCancelRequest) => void;
  onCancelAction: () => void;
  bookingNumber: string;
}

const CancelRequest = (props: Props): JSX.Element => {
  const { t } = useTranslation('cancel-request', fallback, Keys);
  const { onSendAction, onCancelAction, bookingNumber } = props;
  const [freeText, setFreeText] = useState<string>('');

  function buildRequest(): ApiCancelRequest {
    const request: ApiCancelRequest = {
      bookingNumber,
      text: freeText
    };
    return request;
  }

  return (
    <div className="iso__group_request">
      <Row>
        <Col>
          <div className="font-weight-bold">{t(Keys.mainLabel)}</div>
          <div className="mt-2">{t(Keys.travelDetailsInfo)}</div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Input
            value={freeText}
            onChange={(evt): void => setFreeText(evt.target.value)}
            type="textarea"
            rows="5"
          />
        </Col>
      </Row>
      <Row className="mt-2 justify-content-end">
        <Col className="col-auto">
          <Button outline color="primary" onClick={(): void => onCancelAction()}>
            <div className="p-1">{t(Keys.button.close)}</div>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            onClick={(): void => {
              onSendAction(buildRequest());
            }}
          >
            <div className="p-1">{t(Keys.button.send)}</div>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default CancelRequest;
